import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'
Vue.use(Vuex)

import Rest from './../services/rest'
export const store = new Vuex.Store({
  state: {
    is401ToastShown: false,
    defaultGColor: 'bg-green',
    possibleColors: ['bg-green', 'bg-red', 'bg-aqua', 'bg-yellow', 'bg-purple', 'bg-blue', 'bg-teal', 'bg-maroon', 'bg-gray', 'bg-olive', 'bg-orange', 'bg-fuchsia'],
    groupList: [],
    tmpAddExercises: null,
    subgroupsBreadcrumbs: [],
    adminBreadcrumbs: [],
    selectedGroup: {id: 1, color: null, empty: true, years: [], selectedYear: {exams: []}, subgroups: [], subgroupExercises: [], breadcrumbs: []}, // so no initial warnings
    selectedGroupId: null,
    initialSelectedGroup: {id: 1, color: null, empty: true, years: [], selectedYear: {exams: []}},
    selectedYear: {id: 1, empty: true},
    initialSelectedYear: {id: 1, empty: true},
    avatarUrl: '/static/avatar.png',
    mizsUrl: '/static/MIZS_slo.jpg',
    osnovniUrl: '/static/osnovni_EU.jpg',
    // showResetForm: false, // /admin colapse functionality start
    adminpanel: {
      colapseEditGroup: true,
      colapseCreateGroup: true,
      colapseCreateYear: true,
      colapseEditYear: true,
      saveResult: false,
      deleteRefresh: false,
      exercises: {
        colapseCreateDaily: true,
        colapseEditDaily: true,
        colapseCreateSubgroup: true,
        colapseEditSubgroup: true,
        colapseShowOrder: true,
        dailyChallenges: [],
        selectedDaily: true,
        subgroups: []
      } // /admin colapse functionality end
    },
    sessionKey: localStorage.getItem('sessionKey'),
    sessionAccessToken: localStorage.getItem('sessionAccessToken'),
    sessionRefreshToken: localStorage.getItem('sessionRefreshToken'),
    language: {
      currentLocale: 'en'
    },
    pictureBaseURL: Rest.baseOfBaseUrl,
    googleSignInParams: {
      client_id: '132085611331-4ol9eas7jt44qfijonkokm1aadd03mv7.apps.googleusercontent.com'
    },
    register: {
      email: '',
      username: '',
      name: '',
      surname: '',
      password: '',
      password2: '',
      studentId: '',
      status: ''
    },
    login: {
      identifier: '',
      password: '',
      status: '',
      rememberMe: false,
      submited: false
    },
    userData: '',
    exam: {
      picker: '',
      announcedDevices: {},
      announcedTableState: {
        sortOrderAfterInitialClick: 'desc', // const
        sortBy: undefined,
        sortOrder: undefined,
        limit: undefined
      },
      mutationDevice: { // announced
        id: '', // all devices only
        identifier: undefined,
        name: '',
        group: '',
        comment: '',
        password: ''
      },
      allDevices: {},
      tableStateAll: {
        sortOrderAfterInitialClick: 'desc', // const
        groups: undefined,
        registered: undefined,
        sortBy: undefined,
        sortOrder: undefined,
        limit: undefined
      }
    },
    exercisesInOrder: [],
    exercisesForOrder: [],
    exercises: {
      allExercises: [],
      selectedExercises: [],
      tableStateAll: {
        sortOrderAfterInitialClick: 'desc', // const
        tagFilterType: undefined,
        tagIds: undefined,
        sortBy: undefined,
        sortOrder: undefined,
        limit: undefined,
        query: ''
      },
      submitExercise: {
        id: undefined,
        lngs: undefined, // on exercise
        isSolvedCorrectly: undefined, // my prop
        exerciseVersionId: undefined, // required
        submitType: undefined, // tmp, final
        questionGUID: undefined, // required
        languageCode: undefined, // required, display language of the exercise: "sl", "en-us
        classExamId: undefined,
        yearId: undefined,
        subgroupId: undefined,
        dailyChallengeId: undefined,
        answer: undefined // required RADIO: answerGUID, MULTICHOICE: array of [answerGUIDs], NUMERICAL: answered number, ESSAY: answered string.
      },
      incorrectTrigger: {
        exerciseId: undefined,
        correct: undefined
      }
    },
    exerciseForModal: {questions: []},
    statistics: {
      global: [{
        'id': 1,
        'date': '2017-09-28T00:00:00.000Z',
        'registerCount': 1,
        'activeCount': 1,
        'correctCount': 1,
        'wrongCount': 1
      }]
    },
    reports: []
  },
  getters,
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/store/store.js